import { useUser } from 'hooks/user/useUser'
import { ReferralsCSS } from './ReferralsCSS.styled'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'

export const Referrals = () => {
  // start user profile logic
  // open userprofile modal
  const { updateModal } = useYoloModal()
  const { isConnected } = useUser('wallet')
  const USER_PROFILE_MODAL_OBJ = {
    show: true,
    id: 'userProfile',
    backdropBlurred: false,
    props: {
      selectedTabId: 'user-api_tab_three',
    },
  }
  const showUserProfileModal = () => {
    // detailsState.setOpen(false)
    if (isConnected) updateModal(USER_PROFILE_MODAL_OBJ)
    else updateModal({ show: true, id: 'signIn' })
  }
  // end user profile logic

  return (
    <ReferralsCSS>
      <div className='referrals_page_wrapper'>
        <h1>Referrals</h1>
        <h2>Earn rewards based on how many people you refer and sign up for YOLOREKT</h2>
        <button className='get_invite_link ' onClick={showUserProfileModal}>
          Get Invite Link
        </button>
        <div className='process'>
          <h1>3 easy steps to start earning with referrals</h1>
          <div className='steps'>
            <ul>
              <li className='step_number one'></li>
              <li className='step_desc'>Get link</li>
              <li className='step_desc_add'>
                Register or Sign in to get your referral link, found in the navigation link menu at the top.
              </li>
            </ul>
            <ul>
              <li className='step_number two'></li>
              <li className='step_desc'>Invite friends</li>
              <li className='step_desc_add'>Share your referral link with friends and followers.</li>
            </ul>
            <ul>
              <li className='step_number three'></li>
              <li className='step_desc'>Start earning</li>
              <li className='step_desc_add'>You'll share up to 40% commission every time they bid.</li>
            </ul>
          </div>
        </div>

        <div className='referrals_table_wrapper'>
          <div className='grid-body your_bids_iw'>
            <div className='grid-header'>
              <label className='tier'>Tier</label>
              <label>New Weekly Users</label>
              <label>Weekly Bidding Fee</label>
              <label>Reward</label>
              <label>Commission</label>
            </div>
            <div className='grid-content'>
              {/* <!-- ROW -->			   */}
              <div className='yourbids_table_row'>
                <label className='tier'>
                  <div className='tier_icon diamond large'></div>
                  <span>Diamond</span>
                </label>
                <label className='asset open profit'>100+</label>
                <label className='entry open profit'>$5,000+</label>
                <label className='bidamount open profit'>$10 per new user</label>
                <label className='upfront_fee open profit'>40%</label>
              </div>

              {/* <!-- ROW -->			   */}
              <div className='yourbids_table_row'>
                <label className='tier'>
                  <div className='tier_icon gold large'></div>
                  <span>Gold</span>
                </label>
                <label className='asset open profit'>20+</label>
                <label className='entry open profit'>$1,000+</label>
                <label className='bidamount open profit'>$7 per new user</label>
                <label className='upfront_fee open profit'>40%</label>
              </div>

              {/* <!-- ROW -->			   */}
              <div className='yourbids_table_row'>
                <label className='tier'>
                  <div className='tier_icon silver large'></div>
                  <span>Silver</span>
                </label>
                <label className='asset open profit'>1+</label>
                <label className='entry open profit'>$100+</label>
                <label className='bidamount open profit'>$5 per new user</label>
                <label className='upfront_fee open profit'>40%</label>
              </div>
            </div>
          </div>
        </div>

        <div className='contest_rules'>
          <h2>Program rules</h2>
          <ul>
            <li>The YOLOREKT Referral Program is based on the span of 1 week (7 days).</li>
            <li>A program participant can invite as many people as they wish.</li>
            <li>
              To be eligible to receive the weekly cash reward, your referees (those you successfully invite) must
              complete 3 or more bids in the span of 1 week.
            </li>
            <li>
              Additionally to be eligible for the weekly cash reward, the average time of the referees bids must be more
              than 3 minutes.
            </li>
            <li>Minimum bid amount for referees is: $1.00</li>
            <li>The more users you successfully invite, the more commission you will make (up to 40%).</li>
            <li>
              In order maintain your rank (Silver, Gold, Diamond) you must maintain the minimum number of successful
              referees on a weekly basis (with the minimum requirements are described above).
            </li>
            <li>
              If your referee count falls below the required amount for your current tier, you will be demoted ot the
              tier below (if "Silver", your tier badge and status will be removed).
            </li>
            <li>Commission is based on current rank.</li>
            <li>Once the valid referral is counted, please allow the system a little time to update.</li>
            <li>
              The earned referral amount(s) will be distributed and sent to a participant's wallet in the form of USDC.
            </li>
            <li>Any abuse of the referral process will result in an immediate ban.</li>
            <li>
              Yolorekt maintains the right to modify the referral program with or without notice at any time. We might
              not entertain any complaints surrounding referral fees for any reason.
            </li>
          </ul>
          <p></p>
        </div>
      </div>
    </ReferralsCSS>
  )
}
